import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_425: DocMigration = {
  maxSchemaVersion: "0.0.425",
  description:
    "Purge any room layout entities from entity groups, deleting any remaining groups that do not have children",
  apply(json: any) {
    for (const hash in json.entityGroups) {
      const entityRoomLayout = json.entityRoomLayouts?.[hash];

      /**
       * Remove any entityRoomLayout entities that have corresponding hash entry
       * in the entityGroups table, as room layout entities are not group-eligible
       */
      if (entityRoomLayout) {
        delete json.entityGroups?.[hash];
      }
    }

    // Collect each of the group ids mapped to their child hashes
    const groupsToChildHashes: Record<string, string[]> = {};

    for (const id in json.groups) {
      if (!groupsToChildHashes[id]) {
        groupsToChildHashes[id] = [];
      }

      for (const childHash in json.entityGroups) {
        const childGroupId = json.entityGroups[childHash];

        if (childGroupId === id) {
          groupsToChildHashes[id].push(childHash);
        }
      }
    }

    for (const groupId in groupsToChildHashes) {
      const childHashes = groupsToChildHashes[groupId];

      // If there are no child hashes, then we can delete the group
      if (!childHashes.length) {
        delete json.groups?.[groupId];
        delete json.entityRefs?.[groupId];
      }
    }

    return json;
  },
};

export default migration_0_0_425;
